module.exports = __webpack_public_path__ + "static/media/minoan_text_06.30f5f45b.jpg";